export enum EServiceId {
  /** Топ **/
  top = 'top3',
  /** Премиум **/
  premium = 'premium',
  /** Платное **/
  paid = 'paid',
  /** Бесплатное **/
  free = 'free',
}
